import PropTypes from "prop-types";
import React from "react";
import { Card, Col, Row } from "reactstrap";

class Content extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    boxshadow: PropTypes.bool,
    children: PropTypes.any.isRequired,
    cardPrefix: PropTypes.any
  };

  static defaultProps = {
    className: ""
  };

  render() {
    const { className, boxshadow, cardPrefix } = this.props;
    return (
      <Row className={`container-fluid__content ${className}`.trim()}>
        {/* <Col sm="12"> */}
        <Col sm="12" className="noPad">
          {cardPrefix}
          <Card className={boxshadow ? "" : "card-no-boxshadow"}>
            {this.props.children}
          </Card>
        </Col>
      </Row>
    );
  }
}

export default Content;
